import {exists} from '@aboutyou/utils';
import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {PageTypes} from './types';
import {NotFoundRoute} from './NotFoundRoute';
import {usePageTypePathsMap, useRedirectsMap} from './RouterContext';
import {useForce404Page} from './context';
import {Redirect} from './Redirect';
import {useRepairMarketingUrls} from './useRepairMarketingUrls';
import {usePageParamsRedirectUrls} from './usePageParamsRedirectUrls';

export type RoutesMapping = {
  entries: {
    [K in PageTypes]: {
      component: React.ReactNode;
      disabled?: boolean;
    };
  };
};

export const Routes: React.FC<RoutesMapping> = ({entries}) => {
  const pageTypePathsMap = usePageTypePathsMap();
  const redirectsMap = useRedirectsMap();
  const force404Page = useForce404Page();
  const redirectUrl = useRepairMarketingUrls();
  const pageParamRedirectUrl = usePageParamsRedirectUrls();

  return (
    <Switch>
      {force404Page ? (
        <NotFoundRoute path="*">{entries[404].component}</NotFoundRoute>
      ) : null}
      {redirectUrl ? <Redirect to={redirectUrl} /> : null}
      {pageParamRedirectUrl ? (
        <Redirect to={pageParamRedirectUrl} statusCode={301} />
      ) : null}
      {Object.entries(redirectsMap).map(([from, to]) =>
        exists(to) ? (
          <Redirect
            exact
            key={from}
            from={from}
            to={to}
            keepSearch
            statusCode={301}
          />
        ) : null,
      )}
      {Object.entries(pageTypePathsMap)
        .map(([name, paths]) => {
          return paths
            .map(path => {
              const {component, disabled} =
                entries[name as keyof typeof pageTypePathsMap];
              return (
                !disabled && (
                  <Route path={path} exact={path === '/'} key={path}>
                    {component}
                  </Route>
                )
              );
            })
            .filter(exists);
        })
        .flat()}
      <NotFoundRoute path="*">{entries[404].component}</NotFoundRoute>
    </Switch>
  );
};
